"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlCartesian2dTraceGraphicsComponent = void 0;
const tslib_1 = require("tslib");
const rc_js_util_1 = require("rc-js-util");
const gl_cartesian_2d_trace_binder_1 = require("./gl-cartesian-2d-trace-binder");
const core_1 = require("@visualization-tools/core");
/**
 * @public
 * Draws traces for cartesian 2d plots.
 */
class GlCartesian2dTraceGraphicsComponent {
    constructor(traceBinder, cameraBinder) {
        this.traceBinder = traceBinder;
        this.cameraBinder = cameraBinder;
        this.type = core_1.EGraphicsComponentType.Entity;
        DEBUG_MODE && (0, core_1.assertBinder)(traceBinder, gl_cartesian_2d_trace_binder_1.TraceBinderIdentifier);
        this.transform = core_1.GlTransformProvider.createOne(this, this.traceBinder, (updateArg) => updateArg.userTransform, (entity) => entity);
        this.specification = core_1.GlProgramSpecification.mergeProgramSpecifications([
            traceBinder.specification,
            cameraBinder.specification,
            new core_1.GlProgramSpecification(core_1.GlShader.combineShaders([
                core_1.mat3MultiplyVec2Shader,
                vertexShaderPartial,
            ]), fragmentShader, ["ANGLE_instanced_arrays"]),
        ]);
        this.bindings = {
            // 0 min, 1 is max index
            lineGeometryAttribute: new core_1.GlFloatAttribute("traceGc_lineGeometry", new core_1.GlFloatBuffer(new Float32Array([
                0, 0,
                1, 0,
                0, 1,
                1, 1,
            ])), 2),
            screenToClipSizeUniform: new core_1.GlMat3Uniform("traceGc_screenToClipSize", new rc_js_util_1.Mat3.f32()),
        };
    }
    getCacheId() {
        return [
            "GlTraceGraphicsComponent",
            this.cameraBinder.getBinderId(),
            this.traceBinder.getBinderId(),
        ].join("_");
    }
    getLinkableBinders() {
        return [this.traceBinder];
    }
    initialize(componentRenderer) {
        this.traceBinder.initialize(componentRenderer);
        this.cameraBinder.initialize(componentRenderer);
        this.bindings.lineGeometryAttribute.initialize(componentRenderer);
        this.bindings.screenToClipSizeUniform.initialize(componentRenderer);
    }
    onBeforeUpdate(componentRenderer, updateArg) {
        this.bindings.lineGeometryAttribute.bindArray(componentRenderer, componentRenderer.context.STATIC_DRAW);
        const frameId = componentRenderer.sharedState.frameCounter;
        this.bindings.screenToClipSizeUniform.setData(updateArg.canvasDimensions.pixelToClipSize, frameId);
        this.bindings.screenToClipSizeUniform.bind(componentRenderer);
    }
    update(entity, componentRenderer, updateArg) {
        // update dependencies
        this.cameraBinder.update(this.cameraBinder.getBinderData(entity, updateArg, componentRenderer), componentRenderer);
        this.traceBinder.updateInstanced(entity, componentRenderer, 1);
        // draw
        componentRenderer.drawInstancedArrays(componentRenderer.context.TRIANGLE_STRIP, 0, 4, entity.data.getTraceCount());
    }
}
(0, tslib_1.__decorate)([
    rc_js_util_1.Once
], GlCartesian2dTraceGraphicsComponent.prototype, "getCacheId", null);
exports.GlCartesian2dTraceGraphicsComponent = GlCartesian2dTraceGraphicsComponent;
// language=GLSL prefix="#if __VERSION__ >=300 && __VERSION__ < 400 \n #define ATTRIBUTE in \n #define VARYING out \n #else \n #define ATTRIBUTE attribute \n #define VARYING varying \n #endif"
const vertexShaderPartial = new core_1.GlShader(
// @formatter:off
`
ATTRIBUTE lowp vec2 traceGc_lineGeometry;
uniform highp mat3 traceGc_screenToClipSize;

vec2 traceGc_getWidth(float width, vec2 rangeSign, vec2 trianglePosition)
{
    vec2 widthOffset = width * rangeSign.yx * (trianglePosition - 0.5);

    return mat3MultiplyVec2(traceGc_screenToClipSize, widthOffset);
}

// tracePosition [xMin, yMin, xMax, yMax]
vec3 traceGc_getPosition(mat2 tracePosition, float width, vec2 trianglePosition)
{
    vec2 min = tracePosition[0];
    vec2 range = tracePosition[1] - min;
    vec3 basePosition = v_2dCamera_getClipspaceCoords2d(range * trianglePosition + min);
    return basePosition + vec3(traceGc_getWidth(width, sign(range), trianglePosition), 0);
}

void main()
{
    vec3 position = traceGc_getPosition(traceConnector_getPosition(), traceConnector_getWidth(), traceGc_lineGeometry);
    gl_Position = vec4(position, 1);
}
`);
// language=GLSL prefix="#if __VERSION__ >=300 && __VERSION__ < 400 \n #define VARYING in \n #define TEXTURE2D texture \n #else \n #define VARYING varying \n #define TEXTURE2D texture2D \n #endif \n void setFragmentColor(in lowp vec4 color);"
const fragmentShader = new core_1.GlShader(`
void main()
{
    setFragmentColor(traceConnector_getColor());
}
`);
//# sourceMappingURL=gl-cartesian-2d-trace-graphics-component.js.map